import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { LandingComponent } from 'app/pages/landing/landing.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Root path shows landing page directly
    {
        path: '',
        pathMatch: 'full',
        component: LandingComponent,
        title: 'DocNexus'
    },
    {path: 'index', pathMatch : 'full', redirectTo: '/'},

    // Redirect signed-in user to '/dashboard'
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'dashboard'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')}
        ]
    },

    // Main app routes (with layout)
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            // Post-login dashboard — product chooser + cross-vertical stats (T-13 Phase 3)
            {path: 'dashboard', title: 'LinkWeaver — Dashboard', loadChildren: () => import('app/pages/dashboard/dashboard.routes')},
            // Submission Publishing vertical (renamed from /projects in T-13 Phase 2)
            {path: 'submission/projects', title: 'LinkWeaver', loadChildren: () => import('app/pages/projects/projects.routes')},
            {path: 'submission/projects/:projectId', loadChildren: () => import('app/pages/hyper-linking-tool/hyper-linking-tool.routes')},
            // Document Publishing vertical (T-13 Phase 6)
            {path: 'document', title: 'LinkWeaver — Document Publishing', loadChildren: () => import('app/pages/document/document.routes')},
            // Settings page
            {path: 'settings', loadChildren: () => import('app/pages/settings/settings.routes')},
        ]
    },

    // Admin routes (with resolved initial data)
    {
        path: '',
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
        ]
    }
];
